<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="626px" :before-close="closeModal">
    <AlertExclamationRegister size="40" color="#FFAC00" class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center mb-3">
        Valide seu novo e-mail
    </h3>
    <p class="c-ndarkfour text-center">
        Para confirmar a alteração, verifique a caixa de entrada ou spam<br>
        do seu novo e-mail e digite o código que enviamos. Caso cancele,<br> 
        será mantido o e-mail antigo.
    </p>
    <div class="mt-3 pt-3 mb-3 d-flex justify-content-center">
        <div class="d-flex mb-3">
            <el-input ref="first" @keydown.native="focusNextInput('first', 1, $event)" class="code-input" :class="`${getPrimaryColor} ${code.first.length == 1 ? 'is-success' : ''}`" v-model="code.first"/>
            <el-input ref="second" @keydown.native="focusNextInput('second', 2, $event)" class="code-input" :class="`${getPrimaryColor} ${code.second.length == 1 ? 'is-success' : ''}`" v-model="code.second"/>
            <el-input ref="third" @keydown.native="focusNextInput('third', 3, $event)" class="code-input" :class="`${getPrimaryColor} ${code.third.length == 1 ? 'is-success' : ''}`" v-model="code.third"/>
            <el-input ref="fourth" @keydown.native="focusNextInput('fourth', 4, $event)" class="code-input" :class="`${getPrimaryColor} ${code.fourth.length == 1 ? 'is-success' : ''}`" v-model="code.fourth"/>
            <el-input ref="fifth" @keydown.native="focusNextInput('fifth', 5, $event)" class="code-input" :class="`${getPrimaryColor} ${code.fifth.length == 1 ? 'is-success' : ''}`" v-model="code.fifth"/>
        </div>
    </div>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link to="" @click.native="closeModal"  :class="`${getPrimaryColor} c-ndarkfour mr-4`">
            Cancelar
        </router-link>
        <button :class="`btn btn-${getPrimaryColor}`" :disabled="!validateCodeInputs" @click="validateCode">
            Validar e-mail
        </button>
    </span>
</el-dialog>
</template>

<script>
import AlertExclamationRegister from '@/components/icons/AlertExclamationRegister'
export default {
    components: {
      AlertExclamationRegister
    },
    props: {
        dialogVisible: {
            type: Boolean,
            required: true,
            default: false
        },
    },
    data() {
        return {
            code: {
                first: '',
                second: '',
                third: '',
                fourth: '',
                fifth: '',
            },
        }
    },
    computed: {
        validateCodeInputs() {
            return Object.values(this.code).every(input => input.length)
        }
    },
    watch: {
        'code.first': function(value) {
            if (value.length > 1) this.pasteCodeManually('first')
        },
        'code.second': function(value) {
            if (value.length > 1) this.pasteCodeManually('second')
        },
        'code.third': function(value) {
            if (value.length > 1) this.pasteCodeManually('third')
        },
        'code.fourth': function(value) {
            if (value.length > 1) this.pasteCodeManually('fourth')
        },
        'code.fifth': function(value) {
            if (value.length > 1) this.pasteCodeManually('fifth')
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        pasteCodeManually(inputName) {
            const fullText = this.code[inputName]
            const inputEnum = ['first', 'second', 'third', 'fourth', 'fifth']
            const startIndex = inputEnum.indexOf(inputName)
            for (let index = startIndex; index < (fullText.length + startIndex); index++) {
                this.code[inputEnum[index]] = fullText.charAt(index - startIndex)
            }
            const focusInput = (fullText.length + startIndex) < 5 ? fullText.length + startIndex : 4
            this.$refs[inputEnum[focusInput]].focus()
        },
        focusNextInput(inputName, inputOrder, key) {
            if (inputOrder == 5 && this.code[inputName].length) {
                this.$refs[inputName].clear()
            } else {
                this.code[inputName] = this.code[inputName][0] || ''
                const inputEnum = ['first', 'second', 'third', 'fourth', 'fifth']
                if (key.code != 'Backspace' && key.key != 'Control' && inputOrder < 5 && this.code[inputName].length) {
                    this.$refs[inputEnum[inputOrder]].focus()
                } else if (key.code == 'Backspace' && inputOrder > 1 && !this.code[inputName].length) {
                    this.$refs[inputEnum[inputOrder - 2]].focus()
                }
            }
        },
        validateCode() {
            this.$emit('validateCode', `${this.code.first}${this.code.second}${this.code.third}${this.code.fourth}${this.code.fifth}`)
        },
    }
}
</script>

<style lang="scss" scoped>
.code-input {
    border-radius: 6px;
    margin-right: 12px;
    margin-left: 12px;
}
</style>